import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant qui remonte automatiquement la page en haut lors d'un changement de route
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Remonte la page en haut (avec un comportement fluide)
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // 'instant' pour un défilement immédiat, 'smooth' pour un défilement fluide
    });
  }, [pathname]); // Se déclenche à chaque changement de route

  return null; // Ce composant ne rend rien visuellement
}

export default ScrollToTop;
